(function ($, Drupal) {

  'use strict';
  function onDocLittlefootReady(context) {
    const $elements = $(once('initLittlefootBehavior', 'body', context));
    $elements.each(function() {
      function onActivate() {
        if (window.innerWidth <= 768) {
          // document.querySelector('#toTop').classList.add('hard-hide');
        }
      }

      function onDismiss() {
        if (window.innerWidth <= 768) {
          // document.querySelector('#toTop').classList.remove('hard-hide');
        }
      }

      // initialization of footnotes
      littlefoot.default({
        buttonTemplate: '<span class="concorde-footnote"><button aria-label="Footnote <% number %>" aria-expanded="false" class="littlefoot-footnote__button footnote-button" id="<% reference %>"></button></span>',
        activateCallback: onActivate,
        dismissCallback: onDismiss
      });
      // Dynamic numbering
      let footnotes = document.querySelectorAll('.footnote-button ');
      footnotes.forEach((footnote, index) => {
        let number = index + 1;
        footnote.textContent = number;

        // Also number the footnotes list
        let footnoteContent = document.querySelector('#fn' + number + ' .reversefootnote');
        if (footnoteContent) {
          let content = footnoteContent.innerHTML;
          footnoteContent.innerHTML = number + ". " + content;
        }
      });
    });
  }
  Drupal.behaviors.initLittlefoot = {
    attach: function (context) {
      onDocLittlefootReady();
    }
  };

})(jQuery, Drupal);
